import { createFileRoute } from "@tanstack/react-router";
import { SessionsListView } from "@/components/Exercises/PersonalSources/SessionsListView.tsx";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/personal-sources/sessions",
)({
  component: () => <SessionsListView audience="adults" />,
  head: () => ({
    meta: [
      {
        title: "My Reflections Sessions - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "personalSources.history.title",
    navbar: {
      showTitle: true,
    },
  }),
});
